import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
//import globalcontext
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetBatchsByStudentId } from '../../service/BatchService';
import { GetTodayLessonPlanners } from '../../service/LessonPlannerService';
import { GetByUserId } from '../../service/PaymentService';
import { GetByBatchId as GetByBatchIdBatchStudent } from '../../service/BatchStudentService';
import { GetBatchStudentPayments } from '../../service/BatchStudentPaymentService';

function Dashboard() {
  const { isLoading, setIsLoading, isAppError, setAppError, appErrorMessage, setAppErrorMessage, appErrorTitle, setAppErrorTitle, appErrorMode, setAppErrorMode, appUser } = useGlobalContext();

  const [batchs, setBatchs] = useState();
  const [keyword, setKeyword] = useState('');
  const [lessonPlanners, setLessonPlanners] = useState([]);
  const [lessonPlanner, setLessonPlanner] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [payments, setPayments] = useState([]);

  const [totalBatches, setTotalBatches] = useState(0);
  const [todayPlanners, setTodayPlanners] = useState(0);
  const [totalFee, setTotalFee] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalPaidFee, setTotalPaidFee] = useState(0);

  const itemsPerPage = 10;

  const id = appUser._id; // Get the trainer ID from the appUser context

  const fetchBatchList = async (page = 1) => {
    try {
      setIsLoading(true);
      var response = await GetBatchsByStudentId(id, page, itemsPerPage);
      setBatchs(response.batches);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setTotalBatches(response.totalItems); // total mapped batches
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  //fetch lesson planners by trainer id
  const fetchLessonPlanners = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await GetTodayLessonPlanners(id, page, itemsPerPage);
      setLessonPlanners(response.lessonPlanners);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setTodayPlanners(response.totalItems);

    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load lesson planners");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  function formatTimeWithAMPM(timeStr) {
    const [hours, minutes] = timeStr.split(":").map(Number);

    const date = new Date();
    date.setHours(hours, minutes, 0); // Set time

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  }

  //fetch payments by user id with pagination
  const fetchPayments = async () => {
    try {
      setIsLoading(true);
      const response = await GetBatchStudentPayments(id, 1, 9999);
      setPayments(response.payments);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setTotalFee(response.summary.totalFees);
      setTotalPaidFee(response.summary.totalPaid);
      setTotalBalance(response.summary.totalPending);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load payment data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    fetchLessonPlanners(currentPage);
  }, []);

  React.useEffect(() => {
    fetchBatchList();
  }, []);

  React.useEffect(() => {
    fetchPayments();
  }, []);

  return (
    <>
      <Helmet>
        <title>Dashboard | {config.appName} </title>
      </Helmet>
      <div className='container'>

        {/* start of page */}
        <div className='page'>

          <div className='page-heading'>
            <h1>Dashboard</h1>
          </div>

          {/* start of page content */}
          <div className='page-content'>

            {/* start of dashboard counter section */}
            <div className='dashboard-counter-section'>
              <div className='row'>
                <div className='col-12 col-sm-4 col-md-3 col-lg-3'>
                  <div className='dashboard-counter dashboard-counter-blue'>
                    <i class="bi bi-people-fill"></i> {/* Changed from bi-collection */}
                    <span className='counter-value'> {totalBatches} </span>
                    <b>Total Mapped Batches</b>
                  </div>
                </div>
                <div className='col-12 col-sm-4 col-md-3 col-lg-3'>
                  <div className='dashboard-counter dashboard-counter-brown'>
                    <i class="bi bi-calendar-check"></i> {/* Changed from bi-journal-text */}
                    <span className='counter-value'> {todayPlanners} </span>
                    <b>Today's Lesson Planner</b>
                  </div>
                </div>
                <div className='col-12 col-sm-4 col-md-6 col-lg-6'>
                  <div className='dashboard-counter dashboard-counter-green'>
                    <i class="bi bi-currency-rupee"></i> {/* Changed from bi-journal-text */}
                    <span className='counter-value'> {totalFee || 0} </span>
                    <b>Total Overall Fees</b>
                  </div>
                </div>
              </div>
              <div className='row mt-1'>
                <div className='col-12 col-sm-4 col-md-6 col-lg-6'>
                  <div className='dashboard-counter dashboard-counter-orange'>
                    <i class="bi bi-cash-stack"></i> {/* Changed from bi-journal-text */}
                    <span className='counter-value'> {totalPaidFee || 0} </span>
                    <b>Total Paid Fees</b>
                  </div>
                </div>
                <div className='col-12 col-sm-4 col-md-6 col-lg-6'>
                  <div className='dashboard-counter dashboard-counter-red'>
                    <i class="bi bi-exclamation-circle-fill"></i> {/* Changed from bi-journal-text */}
                    <span className='counter-value'> {totalBalance || 0}</span>
                    <b>Total Pending Fees</b>
                  </div>
                </div>
              </div>

            </div>
            {/* end of dashboard counter section */}

            <div className='row'>

              <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                {/* start of portal content */}
                <div className="portal">
                  {/* start of portal title */}
                  <div className='portal-title-bar'>
                    <h4 className='portal-heading'>
                      Today's Sessions [ <span style={{ color: '#f00', paddingLeft: '5px', paddingRight: '5px' }}>
                        {new Date().toLocaleDateString('en-US', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric'
                        })}
                      </span> ]
                    </h4>
                  </div>
                  {/* end of portal title */}

                  {/* start of portal body */}
                  <div className='portal-body'>
                    <div className='table-content'>
                      <table className='table table-bordered table-condensed'>
                        <thead>
                          <tr>
                            <th>Batch</th>
                            <th>Trainer</th>
                            <th>Category</th>
                            <th>Sub Category</th>
                            <th>Course</th>
                            <th>Topic</th>
                            <th>Time</th>
                            <th>Link</th>
                            <th>Status</th>
                            <th>Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(lessonPlanners) && lessonPlanners.length > 0 ? (
                            lessonPlanners.map((lessonPlanner) => (
                              <tr key={lessonPlanner._id}>
                                <td>{lessonPlanner.batchId?.name}</td>
                                <td>{lessonPlanner.trainerId?.username}</td>
                                <td>{lessonPlanner.batchId?.courseId?.categoryId?.name}</td>
                                <td>
                                  {lessonPlanner.batchId?.courseId?.subCategoryIds
                                    ?.map(sub => sub.name)
                                    .join(", ")}
                                </td>
                                <td>{lessonPlanner.batchId?.courseId?.name}</td>
                                <td>{lessonPlanner.lessonTopic}</td>
                                <td>{formatTimeWithAMPM(lessonPlanner.lessonTime)}</td>
                                <td>
                                  {lessonPlanner.link ? (
                                    <a href={lessonPlanner.link} target="_blank" rel="noopener noreferrer">
                                      Join
                                    </a>
                                  ) : (
                                    <span>—</span>
                                  )}
                                </td>
                                <td>{lessonPlanner.status.charAt(0).toUpperCase() + lessonPlanner.status.slice(1)}</td>
                                <td>
                                  <Link to={`/batch-student/manage/${lessonPlanner.batchId?._id}`} className='btn btn-sm btn-danger' style={{ marginTop: '5px' }}>
                                    <FontAwesomeIcon icon="fa-solid fa-coins" /> Payment
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">No lesson planners found.</td>
                            </tr>
                          )}
                        </tbody>

                      </table>
                    </div>
                  </div>
                  {/* end of portal title */}

                </div>
                {/* end of portal content */}
              </div>
            </div>
            <br></br>
          </div>
          {/* end of page content */}

        </div>
        {/* end of page */}

      </div>
    </>
  )
}

export default Dashboard